export function getTypesenseConfig() {
    const searchContainer = document.querySelector('[data-typesense-config]');
    if (!searchContainer) return null;

    try {
        return JSON.parse(searchContainer.getAttribute('data-typesense-config'));
    } catch (e) {
        console.error('Failed to parse Typesense config:', e);
        return null;
    }
}
